function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "aw_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.7,
  d: "M0 0h288v216H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#aw_svg__a)",
  transform: "scale(2.2222)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#39c",
  d: "M0 0v216h324V0H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff0",
  d: "M0 144v12h324v-12H0zm0 24v12h324v-12H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M142.7 28l2.9 3-3-3zm-3 6l3 3-3-3m5.9 0l3 3-3-3z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M139.7 37l3 2.9-3-3m5.9 0l3 3-3-3z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#6cc",
  d: "M136.7 42.8l3 3-3-3z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#c66",
  d: "M142.7 42.8l2.9 3-3-3z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#6cc",
  d: "M148.6 42.8l2.9 3-3-3z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M136.7 45.8l3 3-3-3zm11.9 0l2.9 3-3-3z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M139.7 48.7l3 3-3-3m5.9 0l3 3-3-3z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#6cc",
  d: "M133.8 51.7l3 3-3-3z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#c00",
  stroke: "#fff",
  strokeWidth: 3.7,
  d: "M142.2 34l-20.7 78.5L42.8 134l78.4 20.5 21 78.4 20.9-78.4 78.4-21-78.4-20.9-21-78.4z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#6cc",
  d: "M151.5 51.7l3 3-3-3z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cf",
  d: "M133.8 54.6l3 3-3-3m17.7 0l3 3-3-3z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M136.7 57.6l3 3-3-3m11.9 0l2.9 3-3-3z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#69c",
  d: "M130.8 60.5l3 3-3-3z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#c33",
  d: "M137.7 62.5l1 2-1-2m11.8 0l1 2-1-2z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#69c",
  d: "M154.5 60.5l3 3-3-3z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cf",
  d: "M130.8 63.5l3 3-3-3m23.7 0l3 3-3-3z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M133.8 66.4l3 3-3-3m17.7 0l3 3-3-3z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fill: "#69c",
  d: "M127.9 69.4l3 3-3-3zm29.5 0l3 3-3-3z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M127.9 72.3l3 3-3-3m29.5 0l3 3-3-3z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fill: "#cff",
  d: "M127.9 75.3l3 3-3-3m29.5 0l3 3-3-3z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fill: "#69c",
  d: "M125 78.3l2.9 2.9-3-3z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M130.8 78.3l3 2.9-3-3m23.7 0l3 3-3-3z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fill: "#69c",
  d: "M160.4 78.3l3 2.9-3-3z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M125 81.2l2.9 3-3-3z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  fill: "#c33",
  d: "M131.8 83.2l1 2-1-2m23.6 0l1 2-1-2z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M160.4 81.2l3 3-3-3z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  fill: "#cff",
  d: "M125 84.2l2.9 3-3-3m35.5 0l3 3-3-3z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M127.9 87.1l3 3-3-3m29.5 0l3 3-3-3z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M122 90l3 3-3-3z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  fill: "#c33",
  d: "M128.9 92l1 2-1-2m29.5 0l1 2-1-2z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M163.3 90l3 3-3-3z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M122 93l3 3-3-3m41.3 0l3 3-3-3z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M125 96l2.9 3-3-3m35.5 0l3 3-3-3z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M119 99l3 2.9-3-3z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  fill: "#c33",
  d: "M126 100.9l.9 2-1-2m35.4 0l1 2-1-2z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M166.3 99l3 2.9-3-3z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M119 101.9l3 3-3-3m47.3 0l3 3-3-3z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M122 104.8l3 3-3-3m41.3 0l3 3-3-3z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M116 107.8l3 3-3-3z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  fill: "#c33",
  d: "M122 107.8l3 3-3-3m41.3 0l3 3-3-3z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M169.2 107.8l3 3-3-3m-62 3l3 2.9-3-3z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M110.2 110.7l3 3-3-3m65 0l2.9 3-3-3z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M178 110.7l3 3-3-3m-79.6 3l3 3-3-3z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M101.3 113.7l3 3-3-3z"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M113.1 113.7l3 3-3-3z"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  fill: "#c33",
  d: "M116 113.7l3 3-3-3m53.2 0l3 3-3-3z"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M172.2 113.7l3 3-3-3z"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M184 113.7l3 3-3-3z"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M187 113.7l2.9 3-3-3z"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  fill: "#69c",
  d: "M86.6 116.6l3 3-3-3z"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M89.5 116.6l3 3-3-3z"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  fill: "#cff",
  d: "M92.5 116.6l3 3-3-3z"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M104.3 116.6l3 3-3-3z"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  fill: "#c33",
  d: "M109.2 117.6l2 1-2-1m67.9 0l2 1-2-1z"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M181 116.6l3 3-3-3z"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  fill: "#cff",
  d: "M192.8 116.6l3 3-3-3z"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M195.8 116.6l3 3-3-3z"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  fill: "#69c",
  d: "M198.7 116.6l3 3-3-3m-121 3l3 3-3-3z"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M80.7 119.6l3 3-3-3z"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  fill: "#cff",
  d: "M83.6 119.6l3 3-3-3z"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M95.4 119.6l3 3-3-3z"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  fill: "#c33",
  d: "M100.3 120.6l2 1-2-1m85.6 0l2 1-2-1z"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M189.9 119.6l3 3-3-3z"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  fill: "#cff",
  d: "M201.7 119.6l3 3-3-3z"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M204.6 119.6l3 3-3-3z"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  fill: "#69c",
  d: "M207.6 119.6l3 3-3-3m-138.8 3l3 2.9-3-3z"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cf",
  d: "M71.8 122.5l3 3-3-3z"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M86.6 122.5l3 3-3-3z"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  fill: "#c33",
  d: "M91.5 123.5l2 1-2-1m103.3 0l2 1-2-1z"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M198.7 122.5l3 3-3-3z"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cf",
  d: "M213.5 122.5l3 3-3-3z"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  fill: "#69c",
  d: "M216.4 122.5l3 3-3-3z"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  fill: "#6cc",
  d: "M60 125.5l3 3-3-3z"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cf",
  d: "M63 125.5l2.9 3-3-3z"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M74.8 125.5l2.9 3-3-3zm135.8 0l2.9 3-3-3z"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cf",
  d: "M222.3 125.5l3 3-3-3z"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  fill: "#6cc",
  d: "M225.3 125.5l3 3-3-3m-174.2 3l3 2.9-3-3z"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M54 128.4l3 3-3-3z"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M65.9 128.4l3 3-3-3z"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  fill: "#c33",
  d: "M70.8 129.4l2 1-2-1m144.7 0l2 1-2-1z"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M219.4 128.4l3 3-3-3z"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M231.2 128.4l3 3-3-3z"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  fill: "#6cc",
  d: "M234.2 128.4l3 3-3-3z"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M42.3 131.4l3 3-3-3z"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M45.2 131.4l3 3-3-3z"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M57 131.4l3 3-3-3zm171.3 0l3 3-3-3z"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M240 131.4l3 3-3-3z"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M243 131.4l3 3-3-3m-206.6 3l3 2.9-3-3z"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  fill: "#c66",
  d: "M51.1 134.3l3 3-3-3zm183 0l3 3-3-3z"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M249 134.3l2.9 3-3-3m-206.6 3l3 3-3-3z"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M45.2 137.3l3 3-3-3z"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M57 137.3l3 3-3-3m171.3 0l3 3-3-3z"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M240 137.3l3 3-3-3z"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M243 137.3l3 3-3-3z"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  fill: "#6cc",
  d: "M51.1 140.3l3 2.9-3-3z"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M54 140.3l3 2.9-3-3z"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M65.9 140.3l3 2.9-3-3z"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  fill: "#c33",
  d: "M70.8 141.2l2 1-2-1m144.7 0l2 1-2-1z"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M219.4 140.3l3 2.9-3-3z"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M231.2 140.3l3 2.9-3-3z"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  fill: "#6cc",
  d: "M234.2 140.3l3 2.9-3-3m-174.2 3l3 3-3-3z"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cf",
  d: "M63 143.2l2.9 3-3-3z"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M74.8 143.2l2.9 3-3-3zm135.8 0l2.9 3-3-3z"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cf",
  d: "M222.3 143.2l3 3-3-3z"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  fill: "#6cc",
  d: "M225.3 143.2l3 3-3-3z"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  fill: "#69c",
  d: "M68.8 146.2l3 2.9-3-3z"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cf",
  d: "M71.8 146.2l3 2.9-3-3z"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M86.6 146.2l3 2.9-3-3z"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  fill: "#c33",
  d: "M91.5 147.1l2 1-2-1m103.3 0l2 1-2-1z"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M198.7 146.2l3 2.9-3-3z"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cf",
  d: "M213.5 146.2l3 2.9-3-3z"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  fill: "#69c",
  d: "M216.4 146.2l3 2.9-3-3m-138.7 3l3 3-3-3z"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M80.7 149.1l3 3-3-3z"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  fill: "#cff",
  d: "M83.6 149.1l3 3-3-3z"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M95.4 149.1l3 3-3-3z"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  fill: "#c33",
  d: "M100.3 150l2 1-2-1m85.6 0l2 1-2-1z"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M189.9 149.1l3 3-3-3z"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  fill: "#cff",
  d: "M201.7 149.1l3 3-3-3z"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M204.6 149.1l3 3-3-3z"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  fill: "#69c",
  d: "M207.6 149.1l3 3-3-3m-121 3l2.9 2.9-3-3z"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M89.5 152l3 3-3-3z"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  fill: "#cff",
  d: "M92.5 152l3 3-3-3z"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M104.3 152l3 3-3-3z"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  fill: "#c33",
  d: "M109.2 153l2 1-2-1m67.9 0l2 1-2-1z"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M181 152l3 3-3-3z"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  fill: "#cff",
  d: "M192.8 152l3 3-3-3z"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M195.8 152l3 3-3-3z"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  fill: "#69c",
  d: "M198.7 152l3 3-3-3z"
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M98.4 155l3 3-3-3z"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M101.3 155l3 3-3-3z"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M113.1 155l3 3-3-3z"
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  fill: "#c33",
  d: "M116 155l3 3-3-3m53.2 0l3 3-3-3z"
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M172.2 155l3 3-3-3z"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M184 155l3 3-3-3z"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M187 155l2.9 3-3-3m-79.7 3l3 3-3-3z"
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M110.2 158l3 3-3-3m65 0l2.9 3-3-3z"
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M178 158l3 3-3-3m-62 3l3 2.9-3-3z"
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  fill: "#c33",
  d: "M122 161l3 2.9-3-3m41.3 0l3 3-3-3z"
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M169.2 161l3 2.9-3-3z"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M122 163.9l3 3-3-3m41.3 0l3 3-3-3z"
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M119 166.8l3 3-3-3z"
});

var _ref144 = /*#__PURE__*/React.createElement("path", {
  fill: "#c33",
  d: "M126 168.8l.9 2-1-2m35.4 0l1 2-1-2z"
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M166.3 166.8l3 3-3-3z"
});

var _ref146 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M119 169.8l3 3-3-3m47.3 0l3 3-3-3z"
});

var _ref147 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M125 172.7l2.9 3-3-3m35.5 0l3 3-3-3z"
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M122 175.7l3 3-3-3z"
});

var _ref149 = /*#__PURE__*/React.createElement("path", {
  fill: "#c33",
  d: "M128.9 177.6l1 2-1-2m29.5 0l1 2-1-2z"
});

var _ref150 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M163.3 175.7l3 3-3-3z"
});

var _ref151 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M122 178.6l3 3-3-3m41.3 0l3 3-3-3z"
});

var _ref152 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M127.9 181.6l3 3-3-3m29.5 0l3 3-3-3z"
});

var _ref153 = /*#__PURE__*/React.createElement("path", {
  fill: "#cff",
  d: "M125 184.5l2.9 3-3-3z"
});

var _ref154 = /*#__PURE__*/React.createElement("path", {
  fill: "#c33",
  d: "M131.8 186.5l1 2-1-2m23.6 0l1 2-1-2z"
});

var _ref155 = /*#__PURE__*/React.createElement("path", {
  fill: "#cff",
  d: "M160.4 184.5l3 3-3-3z"
});

var _ref156 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M125 187.5l2.9 3-3-3m35.5 0l3 3-3-3z"
});

var _ref157 = /*#__PURE__*/React.createElement("path", {
  fill: "#69c",
  d: "M125 190.4l2.9 3-3-3z"
});

var _ref158 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M130.8 190.4l3 3-3-3m23.7 0l3 3-3-3z"
});

var _ref159 = /*#__PURE__*/React.createElement("path", {
  fill: "#69c",
  d: "M160.4 190.4l3 3-3-3z"
});

var _ref160 = /*#__PURE__*/React.createElement("path", {
  fill: "#cff",
  d: "M127.9 193.4l3 3-3-3zm29.5 0l3 3-3-3z"
});

var _ref161 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M127.9 196.3l3 3-3-3m29.5 0l3 3-3-3z"
});

var _ref162 = /*#__PURE__*/React.createElement("path", {
  fill: "#69c",
  d: "M127.9 199.3l3 3-3-3m29.5 0l3 3-3-3z"
});

var _ref163 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M133.8 202.2l3 3-3-3m17.7 0l3 3-3-3z"
});

var _ref164 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cf",
  d: "M130.8 205.2l3 3-3-3z"
});

var _ref165 = /*#__PURE__*/React.createElement("path", {
  fill: "#c33",
  d: "M137.7 207.2l1 2-1-2m11.8 0l1 2-1-2z"
});

var _ref166 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cf",
  d: "M154.5 205.2l3 3-3-3z"
});

var _ref167 = /*#__PURE__*/React.createElement("path", {
  fill: "#69c",
  d: "M130.8 208.2l3 2.9-3-3m23.7 0l3 3-3-3z"
});

var _ref168 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M136.7 211.1l3 3-3-3m11.9 0l2.9 3-3-3z"
});

var _ref169 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cf",
  d: "M133.8 214l3 3-3-3zm17.7 0l3 3-3-3z"
});

var _ref170 = /*#__PURE__*/React.createElement("path", {
  fill: "#6cc",
  d: "M133.8 217l3 3-3-3m17.7 0l3 3-3-3z"
});

var _ref171 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcc",
  d: "M139.7 220l3 3-3-3m5.9 0l3 3-3-3z"
});

var _ref172 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M136.7 222.9l3 3-3-3m11.9 0l2.9 3-3-3z"
});

var _ref173 = /*#__PURE__*/React.createElement("path", {
  fill: "#6cc",
  d: "M136.7 225.9l3 3-3-3z"
});

var _ref174 = /*#__PURE__*/React.createElement("path", {
  fill: "#c66",
  d: "M142.7 225.9l2.9 3-3-3z"
});

var _ref175 = /*#__PURE__*/React.createElement("path", {
  fill: "#6cc",
  d: "M148.6 225.9l2.9 3-3-3z"
});

var _ref176 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccf",
  d: "M139.7 231.8l3 3-3-3m5.9 0l3 3-3-3z"
});

var _ref177 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cc",
  d: "M139.7 234.7l3 3-3-3m5.9 0l3 3-3-3m-3 6l3 2.9-3-3z"
});

var SvgAw = function SvgAw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177);
};

export default SvgAw;